import { markActivity } from '../lib/activity';
import { useAuth } from '../context/AuthContext';

/** The countdown shown in the last minute before an idle sign-out. */
export function IdleWarning() {
  const { idleSecondsLeft } = useAuth();
  if (idleSecondsLeft === null) return null;
  return (
    <div className="idle-warning" role="alertdialog" aria-live="assertive" aria-label="Inactivity warning">
      <p>
        You have been inactive. For security you will be signed out in <strong>{idleSecondsLeft}</strong> seconds.
      </p>
      <button type="button" className="spark-btn spark-btn--primary" onClick={() => markActivity()}>
        Stay signed in
      </button>
    </div>
  );
}
